import React from 'react';
import './AttendanceLog.css';

const LOGS = [
  { date: 'Thu 15 May', day: 'Thursday', in: '09:14 AM', out: '—', hours: 'Ongoing', late: '14 min', status: 'late' },
  { date: 'Wed 14 May', day: 'Wednesday', in: '09:02 AM', out: '06:05 PM', hours: '9h 03m', late: '—', status: 'present' },
  { date: 'Tue 13 May', day: 'Tuesday', in: '09:00 AM', out: '06:00 PM', hours: '9h 00m', late: '—', status: 'present' },
  { date: 'Mon 12 May', day: 'Monday', in: '09:32 AM', out: '06:15 PM', hours: '8h 43m', late: '32 min', status: 'late' },
  { date: 'Fri 9 May', day: 'Friday', in: '09:01 AM', out: '06:02 PM', hours: '9h 01m', late: '—', status: 'present' },
  { date: 'Thu 8 May', day: 'Thursday', in: '09:00 AM', out: '06:00 PM', hours: '9h 00m', late: '—', status: 'present' },
  { date: 'Wed 7 May', day: 'Wednesday', in: '—', out: '—', hours: '—', late: '—', status: 'absent' },
  { date: 'Tue 6 May', day: 'Tuesday', in: '09:00 AM', out: '06:05 PM', hours: '9h 05m', late: '—', status: 'present' },
  { date: 'Mon 5 May', day: 'Monday', in: '09:00 AM', out: '06:00 PM', hours: '9h 00m', late: '—', status: 'present' },
  { date: 'Fri 2 May', day: 'Friday', in: '09:18 AM', out: '06:10 PM', hours: '8h 52m', late: '18 min', status: 'late' },
  { date: 'Thu 1 May', day: 'Thursday', in: '09:00 AM', out: '06:00 PM', hours: '9h 00m', late: '—', status: 'present' },
];

const BADGE = {
  present: { label: 'Present', cls: 'bpresent' },
  late: { label: 'Late', cls: 'blate' },
  absent: { label: 'Absent', cls: 'babsent' },
};

const ICON = {
  present: { symbol: '✓', cls: 'present' },
  late: { symbol: '⏱', cls: 'late' },
  absent: { symbol: '✗', cls: 'absent' },
};

export default function AttendanceLog() {
  const present = LOGS.filter(l => l.status === 'present').length;
  const late = LOGS.filter(l => l.status === 'late').length;
  const absent = LOGS.filter(l => l.status === 'absent').length;

  return (
    <div className="log-page">
      <div className="log-stats">
        <div className="log-stat green">
          <div className="ls-val">{present}</div>
          <div className="ls-label">Present</div>
        </div>
        <div className="log-stat amber">
          <div className="ls-val">{late}</div>
          <div className="ls-label">Late</div>
        </div>
        <div className="log-stat red">
          <div className="ls-val">{absent}</div>
          <div className="ls-label">Absent</div>
        </div>
      </div>

      <div className="log-section-label">Full Log — May 2026</div>

      <div className="log-card">
        {LOGS.map((l, i) => (
          <div key={i} className="log-item">
            <div className={`log-icon ${ICON[l.status].cls}`}>
              {ICON[l.status].symbol}
            </div>
            <div className="log-info">
              <div className="log-date">{l.date}</div>
              <div className="log-detail">
                <span>In: {l.in}</span>
                <span>Out: {l.out}</span>
                {l.late !== '—' && <span className="late-tag">+{l.late}</span>}
              </div>
            </div>
            <div className="log-right">
              <div className="log-hours">{l.hours}</div>
              <span className={`badge ${BADGE[l.status].cls}`}>
                {BADGE[l.status].label}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}